export default "__VITE_PUBLIC_ASSET__2b3c300b__"